import React from "react";
import { Typography, Grid, ButtonGroup, Button } from "@material-ui/core";
import HOME_BANNER from "../assets/images/EIT_HOME_BANNER.jpg";
import AboutAIJson from "../data/aboutAI.json";

export default function AboutAI() {
  const [state] = React.useState({
    dataValues: AboutAIJson,
  });

  return (
    <div className="aboutAIContainer">
      <Grid container xs={12} className="banner">
        <Grid item xs={12} sm={12}>
          <Typography className="aboutTitle fadePanel">
            <i className="line">ENTERPRISE IT</i>
          </Typography>

          <img alt="Home Banner" src={HOME_BANNER} style={{ width: "100%" }} />
        </Grid>
        <Grid item xs={12} sm={12}></Grid>
      </Grid>

      <Grid container xs={12} className="homeButtons">
        <Grid item xs={12} className="marginCenter">
          <ButtonGroup variant="contained">
           
            <Button
              variant="contained"
              z
              target="_blank"
              href="https://saiconline.sharepoint.us/teams/EnterpriseITDIFPortal/SitePages/EITIF.aspx"
            >
              EIT Collateral
            </Button>

          </ButtonGroup>
        </Grid>
      </Grid>

      <div className="spacer" />
      <div className="spacer" />
      <div className="spacer" />

      <Grid container xs={12} sm={12} md={12} lg={12} className="introduction">
        <Grid className="marginCenter" item xs={10}>
          <Typography variant="h2" className="subTitle">
            ENTERPRISE IT
          </Typography>
        </Grid>

        <div className="spacer" />

        {state.dataValues.map((item) => {
          return (
            <Grid className="marginCenter" item xs={10} sm={10} md={10} lg={10}>
              <Typography>{item.intro}</Typography>
            </Grid>
          );
        })}
        <div className="spacer" />
        <div className="spacer" />
        <div className="dividerShape" />
      </Grid>
    </div>
  );
}
